
































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import ExpandedItem from '@/components/global/ExpandedItem.vue'

@Component({
  components: { ExpandedItem },
})
export default class PreCheck extends Vue {
  public permissionGiven: boolean | null = null

  public get iOSInfo() {
    const isIpad =
      window.navigator.userAgent.match(/(iPad)/) /* iOS pre 13 */ ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) /* iPad OS 13 */

    const match = window.navigator.userAgent?.match(/OS (\d*)/)
    const mayorVersionStr = isIpad && match ? match[1] : '-1'
    const version = parseInt(mayorVersionStr, 10) ?? -1

    return {
      isIpad,
      version,
    }
  }

  public get browserVersion() {
    // Opera 8.0+
    if (
      // @ts-ignore
      (!!window.opr && !!opr.addons) ||
      // @ts-ignore
      !!window.opera ||
      navigator.userAgent.indexOf(' OPR/') >= 0
    ) {
      return {
        name: 'Opera',
        isBrowserOke: false,
      }
    }

    // @ts-ignore
    if (typeof InstallTrigger !== 'undefined') {
      return {
        name: 'Firefox',
        isBrowserOke: true,
      }
    }

    // Chrome 1 - latest
    // @ts-ignore
    if (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)) {
      return {
        name: 'Google Chrome',
        isBrowserOke: true,
      }
    }

    // Internet Explorer 6-11
    // @ts-ignore
    const isIE = /*@cc_on!@*/ false || !!document.documentMode
    if (isIE) {
      return {
        name: 'Internet Explorer',
        isBrowserOke: false,
      }
    }

    const isNewEdge = !isIE && !!window.StyleMedia
    const isEdge18 = navigator.userAgent.indexOf('Edge/18') != -1
    if (isNewEdge || isEdge18) {
      return {
        name: 'Microsoft Edge',
        isBrowserOke: true,
      }
    }

    const isSafari = navigator.userAgent.indexOf('Safari') > -1
    if (isSafari) {
      const matches = window.navigator.userAgent.match(/Version\/(\d*)./)
      const versionStr = matches && matches.length >= 2 ? matches[1] : '-1'
      const version = versionStr ? parseInt(versionStr, 10) : -1
      if (version >= 12) {
        return {
          name: `Apple Safari ${version > 0 ? version : ''}`,
          isBrowserOke: true,
        }
      } else {
        return {
          name: `Apple Safari ${version > 0 ? version : ''}`,
          isBrowserOke: false,
        }
      }
    }

    return {
      name: null,
      isBrowserOke: null,
    }
  }

  public get resolution() {
    const width = window.screen.width
    const height = window.screen.height
    const isOke = width >= 1024 || height >= 1024

    return {
      dimensions: width && height ? `${width}px × ${height}px` : 'Onbekend',
      isOke,
    }
  }

  public async askPermission() {
    try {
      await navigator.mediaDevices.getUserMedia({ video: true, audio: true })
      this.permissionGiven = true
    } catch (err) {
      this.permissionGiven = false
    }
  }
}
